function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import React, { useState } from 'react';
import { Text, Flex, Stack, Image } from '@tapresearch/ui/components';
import { useCustomBarLegend } from './useCustomBarLegend';
import { OpacityTransitionBox } from '../../../../../shared/OpacityTransitionBox';
import { AnimatePresence } from 'framer-motion';
export function ImageChoiceLegends(param) {
    var data = param.data, answersById = param.answersById, layerData = param.layerData, _param_hiddenSeries = param.hiddenSeries, hiddenSeries = _param_hiddenSeries === void 0 ? [] : _param_hiddenSeries, _param_toggleSerie = param.toggleSerie, toggleSerie = _param_toggleSerie === void 0 ? function() {
    //
    } : _param_toggleSerie;
    var legendsData = useCustomBarLegend({
        data: data,
        layerData: layerData,
        hiddenSeries: hiddenSeries,
        answersById: answersById
    });
    return data ? /*#__PURE__*/ React.createElement(Stack, null, legendsData.map(function(legendData, index) {
        return /*#__PURE__*/ React.createElement(ImageChoiceLegend, {
            key: "legend-".concat(index),
            onClick: function() {
                return toggleSerie(legendData.id);
            },
            borderColor: legendData.color,
            imageUrl: answersById[legendData.id].image.url,
            textColor: legendData.textColor,
            label: legendData.label
        });
    })) : null;
}
function ImageChoiceLegend(param) {
    var onClick = param.onClick, borderColor = param.borderColor, imageUrl = param.imageUrl, textColor = param.textColor, label = param.label;
    var _useState = _sliced_to_array(useState(false), 2), isHovering = _useState[0], setIsHovering = _useState[1];
    return /*#__PURE__*/ React.createElement(Flex, {
        alignItems: "center",
        w: "228px",
        cursor: "pointer",
        _hover: {
            fontWeight: 'bold'
        },
        onClick: onClick,
        border: "1px solid",
        borderColor: borderColor,
        paddingX: "2",
        paddingY: "1",
        borderRadius: "md",
        position: "relative"
    }, /*#__PURE__*/ React.createElement(Image, {
        width: "6",
        src: imageUrl,
        onMouseEnter: function() {
            return setIsHovering(true);
        },
        onMouseLeave: function() {
            return setIsHovering(false);
        }
    }), /*#__PURE__*/ React.createElement(AnimatePresence, null, isHovering && /*#__PURE__*/ React.createElement(OpacityTransitionBox, {
        bottom: "36px",
        left: "8px",
        h: "180px",
        w: "180px",
        bgColor: "white",
        position: "absolute",
        duration: 1,
        zIndex: 1
    }, /*#__PURE__*/ React.createElement(Image, {
        w: "100%",
        src: imageUrl,
        alt: label
    }))), /*#__PURE__*/ React.createElement(Text, {
        fontSize: "sm",
        ml: "2",
        textColor: textColor
    }, label));
}
